import { ExpandMoreOutlined } from '@mui/icons-material';
import { Box, Button, Collapse } from '@mui/material';
import { useId, useState, type ReactNode } from 'react';

/** 설정 요약을 유지하면서 덜 자주 확인하는 규칙과 이력을 펼쳐 봅니다. */
export function AbsenceSettingsDisclosure({ label, children, defaultOpen = false, open: controlledOpen, onOpenChange, animate = true }: {
  label: string; children: ReactNode; defaultOpen?: boolean; open?: boolean; onOpenChange?: (open: boolean) => void; animate?: boolean;
}) {
  const [internalOpen, setOpen] = useState(defaultOpen);
  const open = controlledOpen ?? internalOpen;
  const id = useId();
  return <Box sx={{ minWidth: 0 }}>
    <Button variant="text" color="inherit" aria-expanded={open} aria-controls={id}
      endIcon={<ExpandMoreOutlined sx={{ transform: open ? 'rotate(180deg)' : undefined }} />}
      onClick={() => { setOpen(!open); onOpenChange?.(!open); }}>{label}</Button>
    <Collapse in={open} id={id} timeout={animate ? undefined : 0}>
      <Box sx={{ pt: 1.5, minWidth: 0 }}>{children}</Box>
    </Collapse>
  </Box>;
}
